import axios from "axios";
import { auth, authReady } from "../../../lib/firebase";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

function handleLogout() {
    localStorage.removeItem("Firebase Auth");
    localStorage.removeItem("okta-token-storage");
    window.location.href = "/";
}

const UpdateLocalStorageToken = (token, user) => {
    try {
        let firebaseAuth = JSON.parse(localStorage.getItem("Firebase Auth"));

        if (!firebaseAuth) {
            firebaseAuth = {
                kind: "identitytoolkit#VerifyPasswordResponse",
                localId: user?.uid || "",
                email: user?.email || "",
                displayName: user?.displayName || "",
                registered: true,
                expiresIn: "3600",
                emailVerified: user?.emailVerified || false,
            };
        }
        firebaseAuth.idToken = token;
        firebaseAuth.accessToken = token;
        localStorage.setItem("Firebase Auth", JSON.stringify(firebaseAuth));
    } catch (error) {
        console.error("Error updating localStorage token:", error);
    }
};

// Automatically add token to every request
axiosInstance.interceptors.request.use(async (config) => {
    try {
        await authReady;

        const user = auth.currentUser;
        if (user) {
            const token = await user.getIdToken();
            config.headers.Authorization = `Bearer ${token}`;
            UpdateLocalStorageToken(token, user);
        }
    } catch (error) {
        console.error("Failed to get auth token", error);
    }
    return config;
});

// Handle errors globally
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await authReady;
                const user = auth.currentUser;
                if (user) {
                    const newToken = await user.getIdToken(true);
                    UpdateLocalStorageToken(newToken, user);
                    originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                    return axiosInstance(originalRequest);
                } else {
                    handleLogout();
                }
            } catch (refreshError) {
                console.error("Token refresh failed", refreshError);
                handleLogout();
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;